<div class="modal-header m-transparent">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-header">
  <div class="d-flex justify-content-center1 text-center">
    <h1 class="modal-title">{{'RESTART_DIALOG.TITLE' | translate}}</h1>
  </div>
</div>
<div class="modal-body">
  <div class="text-center">
    <div class="d-flex justify-content-around justify-content-around-mobile">
      <button class="button app-button button-secondery" (click)="activeModal.dismiss()">{{'RESTART_DIALOG.CANCEL' |
        translate}}</button>
      <button class="button app-button button-primary" (click)="activeModal.close()">{{'RESTART_DIALOG.OK' | translate}}</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/restart-dialog/restart-dialog.component.html